import { memo } from "react";

interface DividerProps {
  className?: string;
}

export const Divider = memo(function Divider({ 
  className = "" 
}: DividerProps) {
  return <div className={`w-full border-t border-gray-200 ${className}`} />;
});
